export const backendURL = 'https://ax-manager-backend-7cf69f3596e3.herokuapp.com/api';
export const devURL = 'https://ax-manager-backend-7cf69f3596e3.herokuapp.com/api';
// export const devURL = 'http://localhost:4321/api';